import { Link } from "react-router-dom";
import { Info } from "lucide-react";

import { Avatar } from "./kit";
import { V3_CARD } from "./v3app";

// V3 building blocks for people and contact views (M08–M10, M50–M57, M112).
export function ProfileHead({ name, place, color, pill = "Für Mitglieder sichtbar", testid = "profile-head" }) {
  return (
    <div className={`${V3_CARD} mb-[11px] flex min-h-[104px] items-start gap-[18px] px-[12px] pb-[22px] pt-[14px] lg:min-h-[175px] lg:gap-[20px] lg:px-[12px] lg:pt-[14px]`} data-testid={testid}>
      <Avatar name={name} color={color} size="h-[52px] w-[52px] text-[15px] lg:h-[64px] lg:w-[64px] lg:text-[18px]" />
      <div className="min-w-0 pt-[4px] lg:pt-[2px]">
        <p className="break-words text-[22px] font-bold leading-[30px] text-v3-ink lg:text-[27px] lg:leading-[36px]" data-testid={`${testid}-name`}>{name}</p>
        {place && <p className="mt-[8px] text-[14px] leading-[20px] text-v3-muted lg:mt-[12px] lg:text-[15px]" data-testid={`${testid}-place`}>{place}</p>}
        {pill && <span className="mt-[12px] inline-flex min-h-[26px] items-center rounded-full bg-v3-lilac px-[12px] text-[12.5px] font-bold text-v3-ink">{pill}</span>}
      </div>
    </div>
  );
}

// Two-part switch of M08 / M56: either both are buttons (tabs) or the inactive part links to another view.
export function SegmentTabs({ items, value, onChange, label, testid }) {
  const base = "flex min-h-[44px] flex-1 items-center justify-center rounded-[8px] px-3 text-[13px] lg:text-[14px] transition-colors";
  return (
    <div className="mt-[17px] flex gap-[4px] rounded-[10px] bg-v3-lilac p-[4px]" role={onChange ? "tablist" : "navigation"} aria-label={label} data-testid={testid}>
      {items.map(([k, l, to]) => {
        const active = k === value;
        const cls = `${base} ${active ? "bg-white font-bold text-v3-magenta shadow-sm" : "text-v3-muted hover:text-v3-ink"}`;
        return to && !active
          ? <Link key={k} to={to} className={cls} data-testid={`${testid}-${k}`}>{l}</Link>
          : <button key={k} type="button" role={onChange ? "tab" : undefined} aria-selected={onChange ? active : undefined} aria-current={!onChange && active ? "page" : undefined}
              onClick={() => onChange && onChange(k)} className={cls} data-testid={`${testid}-${k}`}>{l}</button>;
      })}
    </div>
  );
}

// Lilac info card with a heading (M54 "Wirkung nach Bestätigung", M57).
export function InfoBox({ title, text, icon: Icon = Info, tone = "lilac", testid }) {
  return (
    <div className={`mb-[11px] rounded-[10px] px-[12px] pb-[14px] pt-[11px] ${tone === "sand" ? "bg-v3-sand" : "bg-v3-lilac"}`} data-testid={testid}>
      <p className={`flex items-center gap-[10px] text-[15.5px] font-bold leading-[22px] ${tone === "sand" ? "text-v3-amber" : "text-v3-ink"}`}><Icon className="h-[17px] w-[17px] shrink-0" aria-hidden="true" />{title}</p>
      {text && <p className="mt-[8px] text-[13.5px] leading-[19px] text-v3-muted lg:text-[14px]">{text}</p>}
    </div>
  );
}

export const StagePill = ({ children, testid }) => (
  <span data-testid={testid} className="mb-[11px] inline-flex min-h-[26px] items-center rounded-full bg-v3-sand px-[12px] text-[12.5px] font-bold text-v3-amber">{children}</span>
);
